import { FC } from "react";
import FilterDropdown from "@src/components/ui/filters/FilterDropdown";
import { deprecatedColors } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import { css, StyleSheet } from "aphrodite";
import RadioButton from "@src/deprecatedDesignSystem/components/RadioButton";

type Props<T> = {
  title: string;
  selected: T | undefined;
  options: {
    value: T | undefined;
    label: string;
  }[];
  onChange: (value: T | undefined) => void;
};

const SingleSelectFilter: FC<Props<boolean>> = ({
  title,
  selected,
  options,
  onChange,
}) => {
  return (
    <div>
      <FilterDropdown
        showIcon={false}
        label={title}
        width={240}
        selectedCount={selected !== undefined ? 1 : 0}
        filledStyle
        labelPluralizationSuffix=""
      >
        <div className={css(styles.inputGroup)}>
          <RadioButton
            checked={selected === undefined}
            label="All"
            onClick={() => onChange(undefined)}
            style={{ marginBottom: 12 }}
          />
          {options.map((option) => (
            <RadioButton
              key={`${option.value}-${option.label}`}
              label={option.label}
              checked={selected === option.value}
              onClick={() => onChange(option.value)}
              style={{ marginBottom: 12 }}
            />
          ))}
        </div>
      </FilterDropdown>
    </div>
  );
};

const styles = StyleSheet.create({
  inputGroup: {
    overflowY: "auto",
    maxHeight: 300,
    padding: 16,
    paddingBottom: 4,
    backgroundColor: deprecatedColors.background,
  },
});

export default SingleSelectFilter;
